import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  registerables as registerablesJS,
} from 'chart.js';
import { Color, ChartDataSet } from '../../types/app/chart.types';
import { Chart } from 'react-chartjs-2';
import { Grid } from '@mui/material';
import moment from 'moment';
import 'chartjs-adapter-moment';
import { convertMsToTimeFormat } from '../../utils/core/functions/convertDateTime';
import ResizableBox from '../../components/app/ResizableBox/ResizableBox';
import { GRAY } from '../../utils/core/functions/colors.function';
import { ThemeType } from '../../hooks/useLocalTheme';

ChartJS.register(...registerablesJS);
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
);

interface Props {
  chartData: ChartDataSet[];
  labels: string[];
  displayLegend?: boolean;
  chartTitle?: string;
  localTheme?: ThemeType;
}

export function ChartsStateTimeContainer({
  chartData,
  labels,
  displayLegend = true,
  chartTitle,
  localTheme,
}: Props) {
  const preparedData = {
    labels,
    datasets: chartData.map((dataset: ChartDataSet) => {
      return {
        type: dataset.chartType as any,
        label: dataset.label,
        backgroundColor: dataset.colors.map(
          (color: Color) => 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')',
        ),
        borderColor: dataset.style.borderColor,
        borderWidth: dataset.style.borderWidth,
        data: dataset.y,
        skipNull: true,
        // parsing: false,
      };
    }),
  };

  const setSize = () => {
    if (labels.length < 10) {
      setHeightNum(600);
    }
    if (labels.length > 10) {
      setHeightNum(700);
    }
  };

  const [heightNum, setHeightNum] = useState<any>(0);
  const [isSharedRow, setIsSharedRow] = useState<boolean>(true);
  useEffect(() => {
    let maxLabelLength = 0;
    labels.map((label: any) =>
      maxLabelLength < label.length ? (maxLabelLength = label.length) : '',
    );
    setSize();
    if (labels.length > 10 || maxLabelLength > 30) setIsSharedRow(false);
  }, [preparedData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
      y: {
        type: 'linear',
        position: 'left',
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
        ticks: {
          min: 0,
          max: moment('1970-02-01 23:59:59').valueOf(),
          stepSize: 60000,
          callback: (value: any) => {
            if (value > 86399000) {
              let time = moment(value);
              return time.add(-1, 'hour').add(-1, 'day').format(`D[${'d'}] HH:mm:ss`);
            } else {
              let time = moment(value);
              return time.add(-1, 'hour').format('HH:mm:ss');
            }
          },
        },
      },
    },
    options: {
      animation: false,
    },
    plugins: {
      legend: {
        display: displayLegend,
      },
      title: {
        display: true,
        text: chartTitle ? chartTitle : '',
      },
      tooltip: {
        callbacks: {
          label: function (ms: any) {
            let tmpLabel = convertMsToTimeFormat(ms.raw);
            return tmpLabel;
          },
        },
      },
    },
  };

  return (
    <>
      <Grid
        item
        xs={isSharedRow ? 6 : 12}
        mt={2}
        style={{
          width: '100%',
          // height: isSharedRow ? '80vh' : heightNum,
          padding: 0,
          margin: 0,
        }}
      >
        <ResizableBox
          height={heightNum}
          width={
            isSharedRow
              ? visualViewport && visualViewport.width * 0.4
              : visualViewport && visualViewport.width * 0.84
          }
        >
          <Chart type="bar" data={preparedData} options={options} />
        </ResizableBox>
      </Grid>
    </>
  );
}
